import React, { Component } from 'react';
import { Card, Grid, Button } from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { resetPassword } from '../../services/iDepositService';
import history from '../../../history';

class ResetPassword extends Component {
  state = {
    password: '',
    password2: '',
    token: '',
    error: '',
    info: ''
  };

  UNSAFE_componentWillMount() {
    this.setState({ token: this.props.match.params.token });

    // custom rule will have name 'isPasswordMatch'
    ValidatorForm.addValidationRule('isPasswordMatch', value => {
      if (value !== this.state.password) {
        return false;
      }
      return true;
    });
  }

  componentWillUnmount() {
    ValidatorForm.removeValidationRule('isPasswordMatch');
  }

  handleChange = event => {
    event.persist();
    this.setState({
      [event.target.name]: event.target.value
    });
    this.setState({ error: '' });
    this.setState({ info: '' });
  };

  handleFormSubmit = event => {
    this.setState({ info: 'please wait...' });
    resetPassword({ password: this.state.password2, token: this.state.token }).then(response => {
      if (response.status !== 200) {
        console.error(response);
        this.setState({ info: '' });
        this.setState({ error: response.data.message });
      } else {
        this.setState({ info: response.data.message });
        setTimeout(this.login, 3000);
      }
    });
  };

  forgotUsername = event => {
    history.push(`/session/requestusername`);
  };

  login = event => {
    history.push(`/session/signin`);
  };

  render() {
    let { password, password2 } = this.state;
    return (
      <div className='signup flex flex-center w-100 h-100vh'>
        <div className='p-8'>
          <Card className='signup-card position-relative y-center'>
            <Grid container>
              <Grid item lg={5} md={5} sm={5} xs={12}>
                <div className='p-32 flex flex-center flex-middle h-100'>
                  <img src='/assets/images/Tunl-Logo.png' alt='' />
                </div>
              </Grid>
              <Grid item lg={7} md={7} sm={7} xs={12}>
                <div className='bg-error text-center text-white'>{this.state.error}</div>
                <div className='bg-green text-center text-white'>{this.state.info}</div>
                <div className='p-36 h-100 bg-light-gray'>
                  <ValidatorForm ref='form' onSubmit={this.handleFormSubmit}>
                    <TextValidator
                      className='mb-24 w-100'
                      variant='outlined'
                      label='Password'
                      onChange={this.handleChange}
                      type='password'
                      name='password'
                      value={password}
                      validators={['required']}
                      errorMessages={['this field is required']}
                    />

                    <TextValidator
                      className='mb-24 w-100'
                      variant='outlined'
                      label='Repeat Password'
                      onChange={this.handleChange}
                      type='password'
                      name='password2'
                      value={password2}
                      validators={['isPasswordMatch', 'required']}
                      errorMessages={['Password mismatch', 'This field is required']}
                    />
                    <div className='flex flex-middle'>
                      <Button className='capitalize' variant='contained' color='primary' type='submit'>
                        Change Password
                      </Button>
                    </div>
                  </ValidatorForm>
                </div>
              </Grid>
            </Grid>
          </Card>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({});
export default withRouter(connect(mapStateToProps)(ResetPassword));
